export default __webpack_public_path__ + "static/media/blue-arrow-down.bc8c238f.svg";